export enum LegacyReferralStatusEnum {
  Pending = 1,
  Accepted = 2,
  Ntfc = 3
}

export const LegacyReferralStatusOptions = [
{ id: 1, label: 'Pending' },
{ id: 2, label: 'Accepted' },
{ id: 3, label: 'Ntfc' }
];
